import { render } from "./ExamCode.vue?vue&type=template&id=4ac8f37e&scoped=true"
import script from "./ExamCode.vue?vue&type=script&lang=js"
export * from "./ExamCode.vue?vue&type=script&lang=js"

import "./ExamCode.vue?vue&type=style&index=0&id=4ac8f37e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac8f37e"]])

export default __exports__